export default "__VITE_ASSET__BdkfhJgl__"